import * as React from "react";
const SvgDebug = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	height: 128,
	width: 128,
	...props
}, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("title", null, "computer-bug-search"), /* @__PURE__ */ React.createElement("path", {
	d: "M10.5,2.283a8.9,8.9,0,0,1,3.824.507A9,9,0,1,1,3.347,15.56",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.5px"
}), /* @__PURE__ */ React.createElement("line", {
	x1: 17.226,
	y1: 17.979,
	x2: 23.25,
	y2: 23.25,
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.5px"
}), /* @__PURE__ */ React.createElement("line", {
	x1: 3,
	y1: 6.75,
	x2: 9,
	y2: 6.75,
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.5px"
}), /* @__PURE__ */ React.createElement("line", {
	x1: 3,
	y1: 6.75,
	x2: .75,
	y2: 5.7,
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.5px"
}), /* @__PURE__ */ React.createElement("line", {
	x1: 3,
	y1: 9,
	x2: .75,
	y2: 9,
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.5px"
}), /* @__PURE__ */ React.createElement("line", {
	x1: 3.267,
	y1: 10.983,
	x2: 1.5,
	y2: 12.75,
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.5px"
}), /* @__PURE__ */ React.createElement("line", {
	x1: 9,
	y1: 6.75,
	x2: 11.25,
	y2: 5.7,
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.5px"
}), /* @__PURE__ */ React.createElement("line", {
	x1: 9,
	y1: 9,
	x2: 11.25,
	y2: 9,
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.5px"
}), /* @__PURE__ */ React.createElement("line", {
	x1: 8.733,
	y1: 10.983,
	x2: 10.5,
	y2: 12.75,
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.5px"
}), /* @__PURE__ */ React.createElement("line", {
	x1: 5.095,
	y1: 3.14,
	x2: 3.9,
	y2: .75,
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.5px"
}), /* @__PURE__ */ React.createElement("line", {
	x1: 6.905,
	y1: 3.141,
	x2: 8.1,
	y2: .75,
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.5px"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 3,
	y: 3,
	width: 6,
	height: 9.75,
	rx: 3,
	ry: 3,
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.5px"
}));
export { SvgDebug as ReactComponent };
